export const COLOR_CODES = {
  GREEN: "#009830",
  RED: "#c3352b",
  LOGO_BLUE: "#2F324C",
  DARK_YELLOW: "#e48300",
  BLACK: "#000",
  LOGO_AQUA: "#02B9A1",
};
